import { createContext, useContext } from 'react';

/**
 * The open dialog or sheet a menu, popover or tooltip belongs to. Overlays portal into it, so one
 * opened from inside a modal stacks above the modal's content instead of under its scrim — the z
 * scale (dropdown 40 < modal 60) stays as Waypoint defines it.
 */
export const LayerContext = createContext<HTMLElement | null>(null);

/** The element overlays should portal into; undefined = the document body. */
export const useLayerContainer = (): HTMLElement | undefined => useContext(LayerContext) ?? undefined;
